<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Import</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <form enctype="multipart/form-data">
          <div class="form-group">
            <label for="ddlImportType">Type</label>
            <select class="form-control" id="ddlImportType" v-model="file_import.type">
              <option value="0">Select..</option>
              <option value="device">Device</option>
              <option value="schedule">Schedule</option>
              <option value="and_clock">AND Clock</option>
              <option value="hub_2">HUB 2</option>
            </select>
          </div>
          <div class="row" v-if="file_import.type === 'device'">
            <div class="col-5">
              <a href="/upload/files/device_import_template.csv">Template</a>
            </div>
          </div>
          <div class="row" v-else-if="file_import.type === 'schedule'">
            <div class="col-5">
              <a href="/upload/files/schedule_import_template.csv">Template</a>
            </div>
          </div>
          <div class="row" v-else-if="file_import.type === 'and_clock'">
            <div class="col-5">
              <a href="/upload/files/and_clock_import_template.csv">Template</a>
            </div>
          </div>
          <div class="row" v-else-if="file_import.type === 'hub_2'">
            <div class="col-5">
              <a href="/upload/files/hub_2_import_template.csv">Template</a>
            </div>
          </div>
          <br>
          <div class="form-group">
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" class="custom-file-input" accept=".csv" @change="processFile($event)">
                <label class="custom-file-label">{{ file_import.file_name }}</label>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="uploadImportFile()">Upload & Import</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      file_import: {
        type: '0',
        file_name: '',
        file: ''
      }
    }
  },
  methods: {
    processFile (event) {
      this.file_import.file = event.target.files[0]
      this.file_import.file_name = event.target.files[0].name
    },
    uploadImportFile () {
      if (this.file_import.type !== '0') {
        if (this.file_import.file !== '') {
          this.$store.dispatch('uploadImportFile', this.file_import)
        } else {
          alert('Please select a file for the import.')
        }
      } else {
        alert('Please choose a type.')
      }
    }
  }
}
</script>
